module.exports = __webpack_public_path__ + "static/blockchain-e83eb5cbef032441ff454cd601a9cf17.jpeg";